import { call, select, put } from 'redux-saga/effects';

import API from "../../API";
import {loadReportInfoError, loadReportInfoSuccess} from "./report-info-action-creators";

export function* loadReportInfoRequest() {
  const reportUrl = yield select(state => state.report.reportUrl);
  try {
    const result = yield call(API.loadReportInfo, { reportUrl });
    console.log(result, 'RESULT FROM LOAD REPORT INFO');
    if (result.data) {
      yield put(loadReportInfoSuccess(result.data[0]));
    } else {
      yield put(loadReportInfoError("No data"));
    }
  } catch(error) {
    yield put(loadReportInfoError("Something went wrong..."))
  }
}


// WEBPACK FOOTER //
// ./src/modules/report-info/load-report-info-request-saga.js